export const fundraisingManagerAccountOperation = {
  UNCHANGED: 1,
  REMOVE_MANAGER_ACCOUNT: 2,
  NEW_MANAGER_ACCOUNT: 3,
  INVITE: 4
};
